module.exports = __webpack_public_path__ + "img/mc-pause.f84fa942.svg";